<template>
  <div>
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="section-gap">
          <div class="block clearfix">
            <div class="control">
              <label class="label inline-block ">状态</label>
              <input type="radio" :value="-1" v-model="search.status" name="open">全部
              <input type="radio" :value="1" v-model="search.status" name="open">开启
              <input type="radio" :value="0" v-model="search.status" name="open">关闭
            </div>
            <div class="control">
              <label class="label inline-block ">专题展示时间</label>
              <el-date-picker
                v-model="search.startTime"
                type="datetime"
                placeholder="选择开始时间">
              </el-date-picker>
              <span>~</span>
              <el-date-picker
                v-model="search.endTime"
                type="datetime"
                placeholder="选择结束时间">
              </el-date-picker>
            </div>
            <!-- <div class="control" >
              <div style="display: flex;">
                <label class="label inline-block ">负责人</label>
                <v-select :selected="ownner" :options="ownners" :show-labels='false' label="username" @update="updateOwnner"  placeholder="请选择" style="width: 200px;"></v-select>
              </div>
            </div> -->
          </div>
          <div class="block">
            <div class="control">
              <label class="label inline-block">ID</label>
              <input class="input width-2" v-model="search.topicId"/>
            </div>
            <div class="control">
              <label class="label inline-block">名称</label>
              <input type="text" class='input width-2' v-model='search.name'>
            </div>
            <div class="control">
              <label class="label inline-block">分类</label>
              <span class="select">
                 <select class="width-2" v-model="search.categoryId">
                    <option value="0">全部</option>
                    <option v-for="(item,index) in categories" :value="item.categoryId">{{item.name}}</option>
                  </select>
              </span>
              <button class="button is-info" @click="searchCLick" style="margin-left: 20px;">搜索</button>
              <button class="button is-info" @click="clear" style="margin-left: 20px;">清空</button>
            </div>
          </div>
        </div>
      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="clearfix">
          <div class="fleft">
            <router-link class="button is-success" :to="{name:'cyzsTopicEdit'}">新增专题</router-link>
          </div>
          <el-pagination
            v-if="count > 0"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="count"
            class="fright">
          </el-pagination>
        </div>
        <table class="table is-bordered margin-top">
          <thead>
          <tr>
            <td>专题ID</td>
            <td>专题名称</td>
            <td>当前状态</td>
            <td>分类</td>
            <td>待放行/已放行/内容数量</td>
            <td>展示时间段</td>
            <td>喜欢数</td>
            <td>责任人</td>
            <td>快速开关</td>
            <td>操作</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in topicList" v-if='item.topicId'>
            <td>{{item.topicId}}</td>
            <td>{{item.name}}</td>
            <td>
              <span v-if="item.status">开启</span>
              <span v-else="">关闭</span>
            </td>
            <td>{{item.categoryName}}</td>
            <td>{{item.waitVerifiedCount}}/{{ item.verifiedCount }}/{{item.contentCount}}</td>
            <td>{{item.startTime}} ~ {{item.endTime}}</td>
            <td>{{item.collectCount}}</td>
            <td style="width: 140px;">
              <div v-if="item.administrator !== undefined">
                <span>{{ item.administrator }}</span>
                <a class="" @click="onFix(item, index)">修改</a>
              </div>
            </td>
            <td>
              <el-switch
                v-model="item.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="changeStatus(item,'switch')"
                inactive-color="#ff4949">
              </el-switch>
            </td>
            <td>
              <span class="button is-info" @click="goEdit(item)">编辑</span>
              <button class='button is-success' @click='goToArticle(item.name, item.topicId)'>动态</button>
            </td>
          </tr>
          </tbody>
        </table>
      </article>
    </div>
    <div v-if="count > 0" class="clearfix">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="count"
        class="fright">
      </el-pagination>
    </div>
    <el-dialog title="修改负责人" :visible.sync="modal.visible">
      <div>
        <label class="label inline-block">专题</label>
        <span>{{ modal.showTopicValue }}</span>
      </div>
      <div>
        <label class="label inline-block">修改负责人</label>
        <el-select v-model="modal.ownner.username" filterable placeholder="请选择" @change="updateModalOwnner">
          <el-option
            v-for="item in ownners"
            :key="item.userId"
            :label="item.username"
            :value="item.userId">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modal.visible = false">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
  import { getTimeByDateStr, formatDate } from 'UTILS/date'


  export default {
    data(){
      return {
        userId: -1,
        modal: {
          visible: false,
          ownner: {
            userId: -1,
            username: '全部',
          },
          userId: 0,
          showTopicValue: '',
        },
        ownner: {
          userId: -1,
          username: '全部',
        },
        search:{
          categoryId:0,
          status:-1,
          startTime:"",
          endTime:"",
          topicId:"",
          name:""
        },
        topicList:[],
        categories:[],
        count:0,
        page:1,
        pageSize: 10,
        topicNameList:[],//专题名称列表
        showTopicModal: {
          topicId: 0,
          userId: 0,
        },
        ownners: [],
      }
    },
    computed: {

    },
    mounted(){
      if (this.$route.query.page) {
        this.page = this.$route.query.page*1;
      }
      if(this.$route.query.searchParams){
        this.search = Object.assign(this.search,JSON.parse(this.$route.query.searchParams));
      }
      this.getTopicList();
      this.getAllOperator();
    },
    methods: {
      //责任人编辑点击监听
      MODAL_OK_EVENT(){
        let _params = {
          topicId: this.showTopicModal.topicId,
          userId: this.showTopicModal.userId,
        }
        this.updateTopic(_params);
      },
      //分页监听
      handleCurrentChange(value){
        if(this.page !== value){
          this.page = value;
          this.getTopicList();
        }
      },
      searchCLick(){
        this.getTopicList();
      },
      //获取列表
      getTopicList(){
        let params = Object.assign({},this.search);
        params.page = this.page;
        params.pageSize = this.pageSize;
        params.administrator = this.userId;

        if (params.startTime && params.endTime && params.startTime > params.endTime) {
          this.$message("开始时间必须小于结束时间")
        }
        params.startTime = getTimeByDateStr(params.startTime)
        params.endTime = getTimeByDateStr(params.endTime)

        HttpRequest.get("/admin.php?method=blogger.getTopicList",params, true).then((response) => {
          _.each(response.data.list,(item,index)=>{
            item.startTime = formatDate(item.startTime,'yyyy-MM-dd hh:mm:ss');
            item.endTime = formatDate(item.endTime,'yyyy-MM-dd hh:mm:ss');
          })
          this.topicList = response.data.list;
          this.categories = response.data.categories;
          this.count = response.data.count;
        }, (response) => {

        });

      },
      onFix(_obj, _index) {
        console.log(_obj)
        this.modal.visible = true;
        this.modal.showTopicValue = _obj.name;
        this.showTopicModal.topicId = _obj.topicId;
        this.modal.ownner.username = _obj.administrator;
      },
      goEdit(_obj) {
        this.$router.push({
          name: 'cyzsTopicEdit',
          query: {
            topicId: _obj.topicId,
            page: this.page,
            searchParams: JSON.stringify(this.search),
          }
        })
      },
      goToArticle(name, topicId) {
        this.$router.push({
          name: 'articleList',
          query: {
            topicId: topicId,
            searchParams: JSON.stringify({selectedTopic: {name: name, topicId: topicId}}),
            status:"1",
          }
        })
      },
      clear() {
        this.$router.push({
          name: 'cyzsTopicList',
        })
        this.page = 1;
        this.ownner = {};
        this.search = {
          categoryId:0,
          status:-1,
          startTime:"",
          endTime:"",
          topicId:"",
          name:"",
        };
      },
      updateTopic(_val,type) {
        let _topicId, _field, _value;
        if (type == 'switch') {
          // 列表内切换开关；
          _topicId = _val.topicId*1;
          _field = 'status';
          _value = _val.status && 1 || 0;
        } else {
          // 弹框修改责任人；
          _topicId = _val.topicId;
          _field = 'administrator';
          _value = _val.userId && _val.userId || ''; // 如果userId 存在；则取 userId ；否则传空；
        }
        let params = {
          topicId: _topicId,
          field: _field,
          value: _value,
        }
        HttpRequest.post("/admin.php?method=fashion.updateTopic",params, true).then((response) => {
          this.modal.visible = false;
          this.$message('修改成功！');
          setTimeout(()=>{
            this.getTopicList();
          },2000);
        }, (response) => {

        });
      },
      getAllOperator() {
        HttpRequest.get('/admin.php?method=fashion.getOperatorList', {}).then(response => {
          if (response.data) {
            this.ownners = response.data.admin;
            this.ownners.unshift({
              userId: -1,
              username: '全部'
            });
          }
        })
      },
      updateModalOwnner(_val) {
        this.showTopicModal.userId = _val > 0 ? _val :0;
        this.showTopicModal.userName = _.findWhere(this.ownners, {userId:_val}).username;
      },
      changeStatus(data,type){
        this.updateTopic(data,type)
      }
    }
  }
</script>
